/**
 * HHT1 TimeLine Contents 정보
 * @type {string[]}
 */

export const HHT1_EP13_ANSWERS = [
    'At school, Harry and his classmates are making a list of their favorite food, place, thing to do, and game.',
    'Harry wonders what he should write.',
    'Eventually, he chooses asparagus, library, reading, and chess. ',
    'The teacher tells the kids to find classmates who have the same favorite things. ',
    'Harry talks to his classmates around him.',
    'But nobody likes Harry’s favorite things. He feels a bit sad. ',
    'The teacher tells Harry to ask her the questions. ',
    'The teacher likes all of his favorite things, especially chess! Harry feels great. ',
    'Harry and the teacher are playing an amazing game of chess. ',
    'Harry captures the teacher who is the king. Harry wins the game!',
    'All the kids love watching Harry play chess. They want Harry to teach them how to play. ',
];

// export const HHT1_EP13_ANSWER_SOUNDS = [
//     '/1_EP13_SB_TL_01.mp3',
//     '/1_EP13_SB_TL_02.mp3',
//     '/1_EP13_SB_TL_03.mp3',
//     '/1_EP13_SB_TL_04.mp3',
//     '/1_EP13_SB_TL_05.mp3',
//     '/1_EP13_SB_TL_06.mp3',
//     '/1_EP13_SB_TL_07.mp3',
//     '/1_EP13_SB_TL_08.mp3',
//     '/1_EP13_SB_TL_09.mp3',
//     '/1_EP13_SB_TL_10.mp3',
//     '/1_EP13_SB_TL_11.mp3',
// ];

export const HHT1_EP13_ANSWER_SOUNDS = [
    '/4796ba91e8b57da3b638cbe3a74166e5.mp3',
    '/885838ec51e4cd689b18857030a9314d.mp3',
    '/1a825c2f7be8eecd101c183deb9b8119.mp3',
    '/34354546b001d09db2da7703fd671bd0.mp3',
    '/4d386a292a949f32dbc2a562ac4a092e.mp3',
    '/91924a7c0e49503c7baf8fce26313572.mp3',
    '/b1a1dd4f27cd35904c09606584c0043c.mp3',
    '/89c0e7d2305ec13e5c159b0862ee9a8d.mp3',
    '/c62a23a370ad7dcab7ae96fb0dd88dad.mp3',
    '/651a064758daac57a57f6d13693a8d1b.mp3',
    '/3b414067d4f6687c99e49bf9c4fef54b.mp3',
];

export const HHT1_EP13_QUIZ_ITEMS = [{
    'A': HHT1_EP13_ANSWERS[9],
    'B': HHT1_EP13_ANSWERS[1],
    'SoundIndexA': 9,
    'SoundIndexB': 1,
    'answer': HHT1_EP13_ANSWERS[1],
    'sound': [2],
    'exception': false,
},
    {
        'A': HHT1_EP13_ANSWERS[3],
        'B': HHT1_EP13_ANSWERS[8],
        'SoundIndexA': 3,
        'SoundIndexB': 8,
        'answer': HHT1_EP13_ANSWERS[3],
        'sound': [4],
        'exception': false,
    },
    {
        'A': HHT1_EP13_ANSWERS[0],
        'B': HHT1_EP13_ANSWERS[5],
        'SoundIndexA': 0,
        'SoundIndexB': 5,
        'answer': HHT1_EP13_ANSWERS[5],
        'sound': [6, 7],
        'exception': true,
    },
    {
        'A': HHT1_EP13_ANSWERS[4],
        'B': HHT1_EP13_ANSWERS[8],
        'SoundIndexA': 4,
        'SoundIndexB': 8,
        'answer': HHT1_EP13_ANSWERS[8],
        'sound': [9, 10],
        'exception': false,
    },

]
